module.exports = __webpack_public_path__ + "img/4.4e0dc5f4.jpg";